import styled from 'styled-components';
import { media } from '../../utils/media';



export const VideoComponent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: calc(45vw - 20px);

  ${media.tablet`
    width: 100%;
    height: 450px;
  `}

  .embed_video {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
  }

  iframe {
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin-bottom: 0;

    ${media.desktop`
      margin-bottom: unset;
    `}
  }
`;

export const Container = styled.div``;

export const CoverWrapper = styled.div`
  overflow: hidden;
  cursor: pointer;
`;

export const ClickCover = styled.img`
  width: 300px;
  height: auto;
  margin: 0 0 25px 0;

  ${media.desktop`
    width: 480px;
  `}
`;
